module.exports = __webpack_public_path__ + "img/smiley.b8e148e3.svg";